import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import NetworkIcon from '@mui/icons-material/Insights';
import MapIcon from '@mui/icons-material/Map';
import PhoneIcon from '@mui/icons-material/PhoneIphone';
import RefIcon from '@mui/icons-material/Timeline';
import FilterNoneIcon from '@mui/icons-material/FilterNone';
import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, Outlet } from 'react-router-dom';
import theme from '../design/theme';
import { LogoutIconButton } from './authentication/LogoutIconButton';
import { useConfig } from './config';

const LayoutWrapper = styled.div`
    display: flex;
    height: 100vh;
    width: 100vw;
`;

const Sidebar = styled.aside`
    width: 62px;
    background-color: ${theme.color.blue.primary};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
`;

const TopSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Nav = styled.nav`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const navLinkClass = css`
    color: ${theme.color.white.main};
    display: flex;
    padding: 8px;
    border-radius: 8px;
    transition: background-color 0.2s, color 0.2s;

    &.active {
        background-color: ${theme.color.white.main};
        color: ${theme.color.blue.primary};
    }

    &:hover {
        background-color: ${theme.color.blue.light};
        color: ${theme.color.blue.medium};
    }
`;

const MainContent = styled.main`
    flex: 1;
    overflow-y: auto;
`;

export const Layout: React.FC = () => {
    const { t } = useTranslation();
    const { enableReference } = useConfig();

    return (
        <LayoutWrapper>
            <Sidebar>
                <TopSection>
                    <Nav>
                        <NavLink to="/map" className={navLinkClass} aria-label="Carte">
                            <Tooltip title={t('menu.map')} placement="right">
                                <MapIcon fontSize="small" />
                            </Tooltip>
                        </NavLink>
                        <NavLink to="/acquisition" className={navLinkClass} aria-label="Sessions">
                            <Tooltip title={t('menu.sessions')} placement="right">
                                <PhoneIcon fontSize="small" />
                            </Tooltip>
                        </NavLink>
                        {enableReference ? (
                            <NavLink to="/reference" className={navLinkClass} aria-label="Références">
                                <Tooltip title={t('menu.reference')} placement="right">
                                    <RefIcon fontSize="small" />
                                </Tooltip>
                            </NavLink>
                        ) : null}
                        <NavLink to="/network-state" className={navLinkClass} aria-label="Etat du réseau">
                            <Tooltip title={t('menu.network')} placement="right">
                                <NetworkIcon fontSize="small" />
                            </Tooltip>
                        </NavLink>
                        <NavLink to="/project" className={navLinkClass} aria-label="Projet">
                            <Tooltip title={t('menu.project')} placement="right">
                                <FilterNoneIcon fontSize="small" />
                            </Tooltip>
                        </NavLink>
                    </Nav>
                </TopSection>
                <LogoutIconButton />
            </Sidebar>
            <MainContent>
                <Outlet />
            </MainContent>
        </LayoutWrapper>
    );
};
